import { UNDEFINED_ID, useDrag } from "./dnd-internal";
import * as typ from "./types";

const useExternalDND = <El extends HTMLElement,>(
  matrix: typ.Matrix, 
  columnWidth: number, 
  extractTransferNumCols: (ev: React.DragEvent<El>) => number,
) => {
  const dragger = useDrag(matrix, columnWidth);

  const dragOver = (ev: React.DragEvent<El>) => {
    const numCols = extractTransferNumCols(ev);
    dragger.drag({
      id: UNDEFINED_ID,
      x: ev.clientX,
      y: ev.clientY,
      numCols,
      col: numCols,
    });
  }

  const dragLeave = () => dragger.stop();
  const stop = () => dragger.stop();

  return {
    dragged: dragger.result,
    dragOver, dragLeave, stop,
  }
};

export default useExternalDND;